/**
 * API Client for Admin Panel
 * Uses shared ApiClient with Auth0 token management
 */

import { ApiClient } from '@rekindle/shared/api';
import { ENV } from '../config/environment';
import { getAccessToken, forceRefreshToken } from './authProvider';
import { logger } from '../utils/logger';

// Create API client instance
export const apiClient = new ApiClient(ENV.API_URL, {
  logger,
  isOnline: async () => navigator.onLine,
});

// Initialize with Auth0 token management
// Note: Don't auto-logout on unauthorized - let react-admin handle auth via checkAuth
apiClient.initialize(
  getAccessToken,
  forceRefreshToken,
  () => {
    // Just log - don't force logout (causes loops on startup)
    // React-admin's checkAuth will handle redirecting to login
    logger.warn('API returned unauthorized - token may be expired');
  }
);
